import { iUser } from '@/entities/user/user.types';
import { iProfile } from '@/entities/profile/profile.types';
import { iUserService } from './user.types';
import { iFirestoreUserModel } from '../firestore/firestore.types';

export default class UserService implements iUserService {
  db: iFirestoreUserModel;

  constructor(db: iFirestoreUserModel) {
    this.db = db;
  }

  create(user: iUser): Promise<iUser> {
    return this.db.create(user);
  }

  usernameIsValid(username: string): Promise<boolean> {
    return this.db.usernameIsValid(username);
  }

  findByUsername(username: string): Promise<iUser> {
    return this.db.findByUsername(username);
  }

  updateUser(user: iUser | iProfile): Promise<iUser> {
    return this.db.updateUserData(user);
  }
}
